import React, { useState, useEffect } from 'react'
import { Card, Radio, Button, message, Typography } from 'antd'
import { BgColorsOutlined } from '@ant-design/icons'
import { backend } from '../../api'

const { Title } = Typography

export default function ThemeAppearance() {
  const [theme, setTheme] = useState(() => localStorage.getItem('app_theme') || 'light')
  const [saving, setSaving] = useState(false)

  const handleSave = async () => {
    setSaving(true)
    try {
      localStorage.setItem('app_theme', theme)
      const res = await backend.updateSettings({ theme })
      if (res.success) {
        message.success('主题设置已保存')
        window.location.reload()
      } else {
        message.error(res.message || '保存失败')
      }
    } catch (err) {
      message.error('保存失败: ' + (err.message || '未知错误'))
    } finally {
      setSaving(false)
    }
  }

  return (
    <div>
      <Title level={4}>主题设置</Title>
      <Card title={<span><BgColorsOutlined /> 主题外观</span>} style={{ maxWidth: 500 }}>
        <div style={{ marginBottom: 24 }}>
          <Radio.Group value={theme} onChange={e => setTheme(e.target.value)}>
            <Radio.Button value="light">亮色模式</Radio.Button>
            <Radio.Button value="dark">暗色模式</Radio.Button>
          </Radio.Group>
        </div>
        <div style={{ color: '#888', fontSize: 13, marginBottom: 16 }}>
          当前: {theme === 'dark' ? '暗色模式' : '亮色模式'}
        </div>
        <Button type="primary" loading={saving} onClick={handleSave}>
          保存设置
        </Button>
      </Card>
    </div>
  )
}
